import React, { useEffect, useState } from "react";
import Button from "../../../components/common/button";
import { useLocation } from "react-router-dom";
import { fetchBankLeadData, updateFirestoreDoc } from "../../../api";
import { db } from "../../../config/firebaseConfig";
import toast from "react-hot-toast";
import Ic_file from "../../../assets/images/Ic_file.svg";
import Ic_download_primary from "../../../assets/images/Ic_download_primary.svg";
import { getDownloadURL, getStorage, ref } from "firebase/storage";
import Ic_trash from "../../../assets/images/Ic_trash.svg";
import FileInfo from "../../../components/FileInfo";
import Modal from "../../../components/common/modal";

export const Documenters: React.FC<{
  getData: any;
  setActiveTab: any;
}> = ({ getData, setActiveTab }) => {
  const location = useLocation();
  const pathSegments = location.pathname.split("/");
  const id = pathSegments.length > 2 ? pathSegments[2] : null;
  const [Entreprenørgaranti, setEntreprenørgaranti] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [documentsForhandstakst, setDocumentsForhandstakst] = useState([]);
  const [Forsikringsbevis, setForsikringsbevis] = useState([]);
  const [Kontrakt, setKontrakt] = useState([]);

  useEffect(() => {
    if (!id) {
      return;
    }

    const getData = async () => {
      const data = await fetchBankLeadData(id);

      if (data && data?.ProjectAccount && data?.ProjectAccount?.documents) {
        setDocuments(data?.ProjectAccount?.documents);
      }
      if (data && data?.Forhandstakst && data?.Forhandstakst?.documents) {
        setDocumentsForhandstakst(data?.Forhandstakst?.documents);
      }

      if (data && data.Documenter) {
        setEntreprenørgaranti(data?.Documenter?.Entreprenørgaranti);
        setForsikringsbevis(data?.Documenter?.Forsikringsbevis);
        setKontrakt(data?.Documenter?.Kontrakt);
      }
    };

    getData();
  }, [id]);

  const [showConfirm, setShowConfirm] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState<number | null>(null);
  const [deleteField, setDeleteField] = useState<string | null>(null);

  const handleDeleteClick = (index: number) => {
    setDeleteIndex(index);
    setShowConfirm(true);
  };

  const handleCancelDelete = () => {
    setShowConfirm(false);
    setDeleteField(null);
    setDeleteIndex(null);
  };

  const handleConfirmPopup = () => {
    if (showConfirm) {
      setShowConfirm(false);
      setDeleteField(null);
    } else {
      setShowConfirm(true);
    }
  };

  const handleConfirmDelete = async () => {
    if (deleteIndex !== null && deleteField && id) {
      try {
        let finalField;
        let setterFunction;
        let firestorePath = `Documenter.${deleteField}`;

        if (deleteField === "Entreprenørgaranti") {
          finalField = Entreprenørgaranti;
          setterFunction = setEntreprenørgaranti;
          firestorePath = `Documenter.Entreprenørgaranti`;
        } else if (deleteField === "Forsikringsbevis") {
          finalField = Forsikringsbevis;
          setterFunction = setForsikringsbevis;
          firestorePath = `Documenter.Forsikringsbevis`;
        } else if (deleteField === "Kontrakt") {
          finalField = Kontrakt;
          setterFunction = setKontrakt;
          firestorePath = `Documenter.Kontrakt`;
        } else if (deleteField === "ProjectAccount.documents") {
          finalField = documents;
          setterFunction = setDocuments;
          firestorePath = `ProjectAccount.documents`;
        } else if (deleteField === "Forhandstakst.documents") {
          finalField = documentsForhandstakst;
          setterFunction = setDocumentsForhandstakst;
          firestorePath = `Forhandstakst.documents`;
        }

        if (finalField && Array.isArray(finalField) && finalField.length > 0) {
          const updatedFiles = finalField.filter(
            (_: any, i: number) => i !== deleteIndex
          );

          await updateFirestoreDoc(db, "bank_leads", id, {
            [firestorePath]: updatedFiles,
          });
          if (setterFunction) {
            setterFunction(updatedFiles);
          }

          toast.success("Deleted successfully", {
            position: "top-right",
          });
          getData();
        }
      } catch (error) {
        console.error("Error deleting file:", error);
        toast.error("Failed to delete file. Please try again.");
      }
    }

    setShowConfirm(false);
    setDeleteIndex(null);
    setDeleteField(null);
  };

  const handleDownload = async (filePath: string) => {
    try {
      if (!filePath) {
        console.error("File path is missing!");
        return;
      }

      const storage = getStorage();
      const fileRef = ref(storage, filePath);
      const url = await getDownloadURL(fileRef);

      const a = document.createElement("a");
      a.href = url;
      a.target = "_blank";
      a.rel = "noopener noreferrer";
      a.download = filePath.split("/").pop() || "download";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  return (
    <>
      <div className="mx-4 md:mx-6 lg:mx-10 mb-28">
        <div className="flex flex-col gap-4 md:gap-5">
          <div className="rounded-lg bg-lightGreen w-full">
            <div className="p-3 md:p-4">
              <h3 className="text-base lg:text-lg font-semibold text-black3">
                Økonomisk plan
              </h3>
            </div>
            <div className="p-1 pt-0">
              <div className="bg-white p-4 rounded-lg border border-gray3 shadow-shadow4">
                {documents && documents.length > 0 ? (
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 lg:gap-6">
                    {documents?.map((file: any, index: number) => (
                      <div
                        className="border border-gray3 rounded-lg p-2 md:p-3 flex items-center justify-between relative w-full"
                        key={index}
                      >
                        <div className="flex items-start gap-2 md:gap-4 truncate">
                          <div className="bg-lightGreen w-10 h-10 rounded-full flex justify-center items-center">
                            <img src={Ic_file} alt="file" />
                          </div>
                          <FileInfo file={file} />
                        </div>
                        <div className="flex items-center gap-2 sm:gap-3 md:gap-4">
                          <div
                            className="cursor-pointer"
                            onClick={() => {
                              handleDeleteClick(index);
                              setDeleteField("ProjectAccount.documents");
                            }}
                          >
                            <img src={Ic_trash} alt="delete" />
                          </div>
                          <div
                            className="cursor-pointer"
                            onClick={() => handleDownload(file)}
                          >
                            <img src={Ic_download_primary} alt="download" />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-gray">
                    Mangler økonomisk plan
                    {/* No Økonomisk plan found! */}
                  </p>
                )}
              </div>
            </div>
          </div>

          <div className="rounded-lg bg-lightGreen w-full">
            <div className="p-3 md:p-4">
              <h3 className="text-base lg:text-lg font-semibold text-black3">
                Dokumenter for forhåndsrente
              </h3>
            </div>
            <div className="p-1 pt-0">
              <div className="bg-white p-4 rounded-lg border border-gray3 shadow-shadow4">
                {documentsForhandstakst && documentsForhandstakst.length > 0 ? (
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 lg:gap-6">
                    {documentsForhandstakst?.map((file: any, index: number) => (
                      <div
                        className="border border-gray3 rounded-lg p-2 md:p-3 flex items-center justify-between relative w-full"
                        key={index}
                      >
                        <div className="flex items-start gap-2 md:gap-4 truncate">
                          <div className="bg-lightGreen w-10 h-10 rounded-full flex justify-center items-center">
                            <img src={Ic_file} alt="file" />
                          </div>
                          <FileInfo file={file} />
                        </div>
                        <div className="flex items-center gap-2 sm:gap-3 md:gap-4">
                          <div
                            className="cursor-pointer"
                            onClick={() => {
                              handleDeleteClick(index);
                              setDeleteField("Forhandstakst.documents");
                            }}
                          >
                            <img src={Ic_trash} alt="delete" />
                          </div>
                          <div
                            className="cursor-pointer"
                            onClick={() => handleDownload(file)}
                          >
                            <img src={Ic_download_primary} alt="download" />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-gray">
                    {/* No Dokumenter for forhåndsrente found! */}
                    Mangler dokumenter for forhåndsrente
                  </p>
                )}
              </div>
            </div>
          </div>

          <div className="rounded-lg bg-lightGreen w-full">
            <div className="p-3 md:p-4">
              <h3 className="text-base lg:text-lg font-semibold text-black3">
                Entreprenørgaranti
              </h3>
            </div>
            <div className="p-1 pt-0">
              <div className="bg-white p-4 rounded-lg border border-gray3 shadow-shadow4">
                {Entreprenørgaranti && Entreprenørgaranti.length > 0 ? (
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 lg:gap-6">
                    {Entreprenørgaranti?.map((file: any, index: number) => (
                      <div
                        className="border border-gray3 rounded-lg p-2 md:p-3 flex items-center justify-between relative w-full"
                        key={index}
                      >
                        <div className="flex items-start gap-2 md:gap-4 truncate">
                          <div className="bg-lightGreen w-10 h-10 rounded-full flex justify-center items-center">
                            <img src={Ic_file} alt="file" />
                          </div>
                          <FileInfo file={file} />
                        </div>
                        <div className="flex items-center gap-2 sm:gap-3 md:gap-4">
                          <div
                            className="cursor-pointer"
                            onClick={() => {
                              handleDeleteClick(index);
                              setDeleteField("Entreprenørgaranti");
                            }}
                          >
                            <img src={Ic_trash} alt="delete" />
                          </div>
                          <div
                            className="cursor-pointer"
                            onClick={() => handleDownload(file)}
                          >
                            <img src={Ic_download_primary} alt="download" />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-gray">
                    {/* No Entreprenørgaranti found! */}
                    Mangler entreprenørgaranti
                  </p>
                )}
              </div>
            </div>
          </div>

          <div className="rounded-lg bg-lightGreen w-full">
            <div className="p-3 md:p-4">
              <h3 className="text-base lg:text-lg font-semibold text-black3">
                Forsikringsbevis
              </h3>
            </div>
            <div className="p-1 pt-0">
              <div className="bg-white p-4 rounded-lg border border-gray3 shadow-shadow4">
                {Forsikringsbevis && Forsikringsbevis.length > 0 ? (
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 lg:gap-6">
                    {Forsikringsbevis?.map((file: any, index: number) => (
                      <div
                        className="border border-gray3 rounded-lg p-2 md:p-3 flex items-center justify-between relative w-full"
                        key={index}
                      >
                        <div className="flex items-start gap-2 md:gap-4 truncate">
                          <div className="bg-lightGreen w-10 h-10 rounded-full flex justify-center items-center">
                            <img src={Ic_file} alt="file" />
                          </div>
                          <FileInfo file={file} />
                        </div>
                        <div className="flex items-center gap-2 sm:gap-3 md:gap-4">
                          <div
                            className="cursor-pointer"
                            onClick={() => {
                              handleDeleteClick(index);
                              setDeleteField("Forsikringsbevis");
                            }}
                          >
                            <img src={Ic_trash} alt="delete" />
                          </div>
                          <div
                            className="cursor-pointer"
                            onClick={() => handleDownload(file)}
                          >
                            <img src={Ic_download_primary} alt="download" />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-gray">
                    {/* No Forsikringsbevis found! */}
                    Mangler forsikringsbevis
                  </p>
                )}
              </div>
            </div>
          </div>

          <div className="rounded-lg bg-lightGreen w-full">
            <div className="p-3 md:p-4">
              <h3 className="text-base lg:text-lg font-semibold text-black3">
                Kontrakt <span className="text-grey">(eks. NS-3425)</span>
              </h3>
            </div>
            <div className="p-1 pt-0">
              <div className="bg-white p-4 rounded-lg border border-gray3 shadow-shadow4">
                {Kontrakt && Kontrakt.length > 0 ? (
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 lg:gap-6">
                    {Kontrakt?.map((file: any, index: number) => (
                      <div
                        className="border border-gray3 rounded-lg p-2 md:p-3 flex items-center justify-between relative w-full"
                        key={index}
                      >
                        <div className="flex items-start gap-2 md:gap-4 truncate">
                          <div className="bg-lightGreen w-10 h-10 rounded-full flex justify-center items-center">
                            <img src={Ic_file} alt="file" />
                          </div>
                          <FileInfo file={file} />
                        </div>
                        <div className="flex items-center gap-2 sm:gap-3 md:gap-4">
                          <div
                            className="cursor-pointer"
                            onClick={() => {
                              handleDeleteClick(index);
                              setDeleteField("Kontrakt");
                            }}
                          >
                            <img src={Ic_trash} alt="delete" />
                          </div>
                          <div
                            className="cursor-pointer"
                            onClick={() => handleDownload(file)}
                          >
                            <img src={Ic_download_primary} alt="download" />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-gray">
                    {/* No Kontrakt found! */}
                    Mangler kontrakt
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white pb-2 bottom-0 fixed w-[calc(100%-16px)] left-2">
        <div className="flex justify-end w-full gap-4 items-center  bg-white z-50 border border-gray3 p-3 md:p-4">
          <Button
            text="Avbryt"
            className="border-2 border-primary text-primary text-base rounded-[34px] h-10 md:h-12 font-semibold relative px-6 md:px-8 py-[10px] flex items-center gap-2"
            onClick={() => setActiveTab(0)}
          />
          <div id="submit">
            <Button
              text="Neste"
              className="border border-primary bg-primary text-white text-base rounded-[34px] h-10 md:h-12 font-semibold relative px-6 md:px-8 py-[10px] flex items-center gap-2"
              onClick={() => setActiveTab(2)}
            />
          </div>
        </div>
      </div>

      {showConfirm && (
        <Modal onClose={handleConfirmPopup} isOpen={true}>
          <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
            <div className="bg-white p-6 rounded-lg">
              <p className="mb-4">Er du sikker på at du vil slette?</p>
              <div className="flex justify-center gap-4">
                <div onClick={handleCancelDelete}>
                  <Button
                    text="Avbryt"
                    className="border border-gray2 text-black text-sm rounded-[8px] h-[40px] font-medium relative px-4 py-[10px] flex items-center gap-2"
                  />
                </div>
                <Button
                  text="Bekrefte"
                  className="border border-primary bg-primary text-white text-sm rounded-[8px] h-[40px] font-medium relative px-4 py-[10px] flex items-center gap-2"
                  onClick={handleConfirmDelete}
                />
              </div>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};
